module.exports = __webpack_public_path__ + "static/media/22ESCWA7.a5a6dd32.jpg";